// API endpoints
export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/auth/login',
        LOGOUT: '/auth/logout',
        REFRESH: '/auth/refresh',
        OTP: '/auth/otp',
    },
    USERS: {
        BASE: '/users',
        BY_ID: (id: string | number) => `/users/${id}`,
        PROFILE: '/users/profile',
    },
    STORE: {
        BASE: '/store',
        OTP: '/store/otp/deeplink/v2',
        BOOT_AUTH: '/boot/auth',
    },
} as const;

// API configuration
export const API_CONFIG = {
    TIMEOUT: 30000, // 30 seconds
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000, // 1 second
} as const;

